import { z } from 'zod';
import { IndicatorType } from '@shared/types';
import { ZigZagInputSchema } from './zig-zag.schema';

export const MasterPatternInputSchema = z.object({
  type: z.literal(IndicatorType.MASTER_PATTERN),
  zigZag: ZigZagInputSchema,
  allow_repainting: z.boolean().optional().default(false),
  show_all_value_lines: z.boolean().optional().default(false),
  value_expiration_diff: z.number().optional()
});

export type MasterPatternInput = z.infer<typeof MasterPatternInputSchema>;
